import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DEFAULT_LOG_LEVEL } from "envConfig";

interface LoggerState {
    value: String;
}

const initialState: LoggerState = {
    value: DEFAULT_LOG_LEVEL,
};

const loggerSlice = createSlice({
    name: 'logger',
    initialState,
    reducers: {
        debug: (state) => {
            state.value = "debug";
        },
        warn: (state) => {
            state.value = "warn";
        },
        info: (state) => {
            state.value = "info";
        },
        error: (state) => {
            state.value = "error";
        },
    },
});

export default loggerSlice.reducer;
export const { debug, warn, info, error } = loggerSlice.actions;